export default __webpack_public_path__ + "static/media/doc-bell_icon.bb77bb59.svg";